<template>
   <div :class="remainingTime > 0 ? 'status in-force' : 'bg-pinterest'"  class="text-white p-1 text-center rounded-bottom font-weight-bold">
      <p class="mb-1" v-if="remainingTime > 0">Tempo restante: {{ formatTime(remainingTime, typeOfLeasePeriod) }}</p>
      <p class="mb-1" v-else>Tempo extra: {{ formatTime(extraTime, typeOfLeasePeriod) }}</p>
   </div>
</template>

<script>
import {formatTime} from "../helpers";

export default {
   props: {
      typeOfLeasePeriod: {
         type: String,
         required: true
      },
      pedalingTime: Number, // Usado quando for "perHour"
      checkin: String, // Usado quando for "daily"
      checkout: String, // Usado quando for "daily"
      numberOfRentalWeeks: Number, // Usado quando for "perWeek"
      numberOfMonthsOfLease: Number, // Usado quando for "monthly"
      statusLog: {
         type: Array,
         required: true
      }
   },
   data() {
      return {
         remainingTime: 0,
         extraTime: 0,
         interval: null,
         counting: false,
         startTime: null
      };
   },
   mounted() {
      this.setStartTime();
      if (this.startTime) {
         this.startTimer();
      }
   },
   methods: {
      setStartTime() {
         const startLog = this.statusLog.find(log => log.statusChangedTo);
         if (startLog) {
            this.startTime = new Date(startLog.changedOn).getTime();
            const now = Date.now();
            const elapsed = Math.floor((now - this.startTime) / 1000);

            let totalDuration = 0;

            switch (this.typeOfLeasePeriod) {
               case 'perHour':
                  totalDuration = (this.pedalingTime || 1) * 3600; // Horas para segundos
                  break;
               case 'daily':
                  if (this.checkin && this.checkout) {
                     totalDuration = Math.floor((new Date(this.checkout).getTime() - new Date(this.checkin).getTime()) / 1000);
                  }
                  break;
               case 'perWeek':
                  totalDuration = (this.numberOfRentalWeeks || 1) * 7 * 24 * 3600; // Semanas para segundos
                  break;
               case 'monthly':
                  totalDuration = Math.round((this.numberOfMonthsOfLease || 1) * 30.44 * 24 * 3600); // Média real de dias por mês
                  break;
            }

            this.remainingTime = Math.max(totalDuration - elapsed, 0);
            this.extraTime = this.remainingTime === 0 ? elapsed - totalDuration : 0;
         }
      },
      startTimer() {
         if (this.counting) return;
         this.counting = true;
         this.interval = setInterval(() => {
            if (this.remainingTime > 0) {
               this.remainingTime--;
            } else {
               this.extraTime++;
            }
         }, 1000);
      },
      formatTime(seconds, typeOfLeasePeriod) {
         return formatTime(seconds, typeOfLeasePeriod)
      }
   },
   beforeDestroy() {
      clearInterval(this.interval);
   }
};
</script>

